import * as stylex from "@stylexjs/stylex";
import { breakpoints } from "./consts.stylex";
/**
 * Named grid areas used by the `gridCenteredMaxWidth` layout (a 3-column
 * centered grid: side / content / side). Distinct from `layoutAreas` in
 * `consts.stylex.ts`, which holds column-line ranges for the site-wide grid.
 */ export const gridCenteredMaxWidthAreas = {
    main: "main",
    banner: "banner"
};
export const layout = {
    gridCenteredMaxWidth: {
        k1xSpc: "xrvj5dj",
        kumcoG: "xyuigjj",
        k9llMU: "x1tu4anv",
        kC13JO: "x1pf5xwn",
        k1C7PZ: "x40hh3e x17ruudj",
        $$css: true
    },
    fullWidth: {
        kzqmXN: "xh8yej3",
        $$css: true
    },
    fullWidthHidden: {
        kzqmXN: "xh8yej3",
        kVQacm: "xb3r6kr",
        $$css: true
    },
    legendSpacer: {
        keoZOQ: "x1xmf6yo",
        $$css: true
    },
    heroSpacer: {
        kZKoxP: "x1vqgdyp",
        $$css: true
    }
};
